/**
 * 题目 V2 tokens 消费开关（question_list / record.question_list 等）
 *
 * true  — 优先用题目 `tokens`（及 split_data[].tokens）驱动 word_en 槽位 / 直接展示
 * false — 完全走旧逻辑（word_en / en 分词等），忽略 tokens（测试期默认关闭）
 *
 * 数据稳定后改为 true 即可全量启用；勿删旧逻辑。
 */
export const USE_QUESTION_V2_TOKENS = true
